import {
    OrderDeliveryDetailsDto,
    OrderDeliveryTypeDto,
} from "services/orders/restModels";
import { formatDate } from "shared/lib/dateTime";
import { localizedText } from "shared/lib/localizedMap";

export interface DetailsRow {
    label: string;
    value: string;
}

const timeLabel = (hour: number | null, minute: number | null): string => {
    if (hour === null && minute === null) return "";

    const pad = (part: number) => String(part).padStart(2, "0");

    return `${pad(hour || 0)}:${pad(minute || 0)}`;
};

const addressLine = (
    building: string | null,
    porch: string | null,
    floor: number | null,
    flat: number | null
): string =>
    [
        building ? `корпус ${building}` : "",
        porch ? `подъезд ${porch}` : "",
        floor === null ? "" : `этаж ${floor}`,
        flat === null ? "" : `кв. ${flat}`,
    ]
        .filter((part) => part !== "")
        .join(", ");

/*
* Способ получения разворачивается в строки «подпись — значение». Сужение по литеральному
* type — единственная типовая проверка, которая здесь реально работает: strictNullChecks в
* проекте выключен, и обращение к чужому полю ловится только им.
*
* Пустые значения не выбрасываем здесь: их отфильтрует вызывающий — так порядок строк
* остаётся на виду одним списком.
* */
export const deliveryDetailsRows = (
    details: OrderDeliveryDetailsDto,
    locale: string
): DetailsRow[] => {
    switch (details.type) {
        case OrderDeliveryTypeDto.toTable:
            return [
                {
                    label: "Стол",
                    value: details.tableTitle ? localizedText(details.tableTitle, locale) : "",
                },
                { label: "Место", value: details.seatId || "" },
            ];

        case OrderDeliveryTypeDto.toAddress:
            return [
                { label: "Имя гостя", value: details.name || "" },
                { label: "Телефон", value: details.phoneNumber },
                { label: "Адрес", value: details.address },
                {
                    label: "Уточнения",
                    value: addressLine(
                        details.building,
                        details.porch,
                        details.floor,
                        details.flat
                    ),
                },
                { label: "Комментарий к адресу", value: details.comment || "" },
            ];

        case OrderDeliveryTypeDto.takeAway:
            return [
                { label: "Имя гостя", value: details.name || "" },
                { label: "Телефон", value: details.phoneNumber },
            ];

        case OrderDeliveryTypeDto.takeAwayToTime:
            return [
                { label: "Имя гостя", value: details.name || "" },
                { label: "Телефон", value: details.phoneNumber },
                {
                    label: "Ко времени",
                    value: [
                        details.date === null ? "" : formatDate(details.date),
                        timeLabel(details.toHour, details.toMinute),
                    ]
                        .filter((part) => part !== "")
                        .join(" "),
                },
            ];

        case OrderDeliveryTypeDto.toVehicle:
            return [
                { label: "Телефон", value: details.phoneNumber },
                {
                    label: "Автомобиль",
                    value: `${details.vehicleBrandName} ${details.vehicleColor} ${details.vehiclePlateNumber}`,
                },
            ];

        case OrderDeliveryTypeDto.insideTheRestaurant:
            return [];
    }
};
